import { EuiSpacer } from '@elastic/eui';
import CGIArticles from 'components/Advanced_User/CGI_Commands/IntroCGIs';
import YoutubeVideoCard from 'components/Software/Home_Automation/YoutubeVideoCard';
import NavButtons from 'components/Advanced_User/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  CGIArticles,
  YoutubeVideoCard,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};